<template v-if="isVisible">
    <Card :closable="false" class="mb-4 border border-surface-200">
        <template #content>
            <div class="typography">
                <h6 class="flex items-center gap-2">
                    <aeg-icon icon="pi pi-credit-card" />
                    <span>Hoe een testbetaling uitvoeren?</span>
                </h6>
                <div>Volgende mogelijkheden om testbetalingen uit te voeren:</div>
                <ol>
                    <li>
                        Betalen met kaart (Approved):<br/>
                        <ul>
                            <li>Bancontact: kaartnummer 6060 0599 9998 9906 3</li>
                            <li>VISA: kaartnummer 4330 2649 3634 4675 - CVV 123</li>
                            <li>MASTERCARD: kaartnummer 5137 0098 0194 3438  - CVV 123</li>
                        </ul>
                    </li>
                    <li>
                        Meer mogelijkheden op: <a
                        href="https://docs.direct.worldline-solutions.com/en/integration/how-to-integrate/test-cases/index"
                        target="_blank" rel="noopener noreferrer">API Test cases</a>
                    </li>
                </ol>
            </div>
        </template>
    </Card>
    <!--    <vl-u-spacer mod-small/>-->
</template>

